import { useState } from 'react';
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native';
import { useMaskedInputProps } from 'react-native-mask-input';

import { FormControlTextInput } from '../form-control-text-input';
import { IconMailFilled } from '../icon';

import { isEmailValid } from './masks';
import { EMAIL_INPUT_ACCESSORY_ID } from './name-input';

import { MaskInputProps } from '.';

export function EmailInput(props: MaskInputProps) {
  const [maskedEmail, setMaskedEmail] = useState(props.value);

  const { onChangeText, value: maskedValue } = useMaskedInputProps({
    value: maskedEmail,
    onChangeText: (masked, _unmasked) => {
      setMaskedEmail(masked);
      props.onChange(_unmasked);
    },
  });

  const handleOnBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    isEmailValid(e.nativeEvent.text);
  };

  return (
    <>
      <FormControlTextInput
        style={{ maxHeight: 48, width: '100%' }}
        autoFocus={props.autoFocus}
        error={props.error ? 'Please enter a valid email' : ''}
        label={'Email Address'}
        placeholder={'Enter Your Email'}
        keyboardType="email-address"
        readOnly={props.readOnly}
        leftIcon={<IconMailFilled size={24} />}
        onChangeText={onChangeText}
        value={maskedValue}
        onBlur={handleOnBlur}
        inputAccessoryViewID={EMAIL_INPUT_ACCESSORY_ID}
      />
    </>
  );
}
